module.exports = __webpack_public_path__ + "static/media/ayanda_english_south_africa.96512c36.mp3";